import { styled } from "styled-components"
import {List, Selector, SelectorProps} from 'antd-mobile'
import React from "react"
import _ from "lodash"


const LabelItemView = styled(List.Item)`
  display: flex;
  margin: 0 10px;
  .adm-list-item-content{
    width: 100%;
    border-bottom: 1px solid #efefef;
  }
  .adm-list-item-content-main{
    flex:1;
    width: 100%;
    .label{
      font-size: 17px;
      flex-shrink: 0;
      margin-right: 10px;
    }
  }
  .label-item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.bottom{
      flex-direction: column;
      align-items: flex-start;
      .text{
        width: 100%;
        margin-top: 10px;
      }
    }
    .text{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      color: rgba(0,0,0,0.45);
    }
  }
`


interface LabelItemProps<T extends (string|number)> extends Omit<SelectorProps<T>,'options'> {
  label:React.ReactNode,
  options?: SelectorProps<T>['options'],
  text?: string
  onClick?():void
  arrow?:boolean,
  optionPostion?: 'right'|'bottom'|'popup'  //默认popup
  addAllChildren?: boolean
} 


export const LabelItem:React.FC<LabelItemProps<string|number>> = (props)=>{
  let { options,arrow = true, optionPostion='popup', value = [],onClick = ()=>{},...reset } = props
  let optionsObj = React.useMemo(()=>{
    return _.mapKeys(options || [],'value')
  },[options])
  const renderOptions = ()=>{
    if(optionPostion == 'popup'){
      return null
    }
    if(!options){
      return null
    }
    return <div>
     <Selector
        { ...reset }
        value={value}
        options={options}
        onChange={(value,extend)=>{
          props.onChange?.(value,extend)
        }}
     />
    </div>
  }

  const renderText = ()=>{
    let value = props.value || []
    if(props.text){
      return props.text
    }
    if(optionPostion != "popup"){
      return null
    }
    if(props.addAllChildren){
      return value.map(item => optionsObj[item]?.label).filter(item => item).join(',')
    }
    return value.map(item => optionsObj[item]?.label || item).join(',')
      // return 
    // if(Array.isArray(value)){
    //   // return text.map(item =>{
    //   //   return optionsObj[item].label
    //   // }).join(',')
    // }
    // return text
  }
  return <LabelItemView arrow={arrow}>
    <div className={`label-item ${optionPostion == 'bottom' ? 'bottom' : ''}`} onClick={  onClick }>
      <div className="label">{props.label}</div>
      <div className="text">
        { renderText() }
        { renderOptions() }
      </div>
    </div>
  </LabelItemView>
}